module.exports = __webpack_public_path__ + "img/2.db275f62.png";